import { AddOutlined } from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'
import type { InternalLabelArea } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { AreaTable } from './AreaTable'
import { Tips } from './Tips'

type Props = {
  onClickExistingArea: (area: InternalLabelArea) => void
  addNewArea: () => void
  errorMessages: string[]
  areas: InternalLabelArea[]
  canSave: boolean
  deleteArea: (id: string) => void
}

export const AreaPanel: FC<Props> = ({
  onClickExistingArea,
  areas,
  canSave,
  addNewArea,
  errorMessages,
  deleteArea,
}) => {
  return (
    <Stack spacing={2} py={2}>
      <Stack sx={{ px: 2, gap: 2 }}>
        <Button
          variant="contained"
          color="secondary"
          size="medium"
          startIcon={<AddOutlined />}
          disabled={!canSave}
          onClick={addNewArea}
          sx={{ width: 'fit-content' }}
        >
          検査箇所を追加
        </Button>
        {errorMessages.map(error => (
          <Typography fontSize={16} key={error} color="error" fontWeight="bold">
            {error}
          </Typography>
        ))}
      </Stack>
      <AreaTable
        onClickArea={onClickExistingArea}
        areas={areas}
        deleteArea={deleteArea}
      />
      <Box px={2}>
        <Tips />
      </Box>
    </Stack>
  )
}
